export default "__VITE_ASSET__C9DWxFEM__"